import { render, staticRenderFns } from "./pointDialog.vue?vue&type=template&id=2e0ae299"
import script from "./pointDialog.vue?vue&type=script&lang=js"
export * from "./pointDialog.vue?vue&type=script&lang=js"
import style0 from "./pointDialog.vue?vue&type=style&index=0&id=2e0ae299&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports